import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design-components/base/eco-img';
import EcoSpace from 'eco-design-components/base/eco-space';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
import EcoCountDown from 'eco-design-components/elements/eco-count-down';
import { fetchPost } from 'lowcode/utils/service/FetchClient';
import { baseUrl } from 'lowcode/utils/service/baseUrl';
import ClipboardJS from 'clipboard';
import { getIsLogin } from '@/utils/cookie';
import EcoLink from 'eco-design/base/eco-link';
// import { createPortal } from 'react-dom';
import Dialog from './Dialog';
import { checks } from './checks';
import { links } from './links';
import { getEmailConfigs } from '../A';
import gtm from '@/utils/gtm';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';

interface ItemType {
    name: string;
    text?: string;
    img: string;
    link?: string;
    linkText?: string;
    href?: string;
}

const B: React.FC = () => {
    const { locale = 'us', query } = useRouter();
    const { t } = useLang('rapidpro');
    const [input, setInput] = useState<string>('');
    const [tip, setTip] = useState<string>('');
    const [submit, setSubmit] = useState(false);
    const [copy, setCopy] = useState(false);
    const [visible, setVisible] = useState(false);
    const CODE = 'PROEF';
    const IS_NA = ['us', 'ca'].includes(locale);
    const IS_EU: boolean = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const IS_JP: boolean = locale === 'jp';
    const [link1, link2] = links[locale] || links.us;
    const [check, setCheck] = useState<boolean>(checks[locale] || checks.us);
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const [countdownEnd, setCountdownEnd] = useState<number>(0);

    const imgs = {
        point2x: 'https://websiteoss.ecoflow.com/upload/image/1749020679365/point2x.png',
        point3x: 'https://websiteoss.ecoflow.com/upload/image/1749020679929/point3x.png',
        point4x: 'https://websiteoss.ecoflow.com/upload/image/1749020679093/point4x.png',
        turntable: 'https://websiteoss.ecoflow.com/upload/image/1749020867672/turntable.png',
        off5: 'https://websiteoss.ecoflow.com/upload/image/1749535012867/off5.png',
        off6: 'https://websiteoss.ecoflow.com/upload/image/1749020678863/off6.png',
        off10: 'https://websiteoss.ecoflow.com/upload/image/1749020680204/off10.png',
        off18: (() => {
            const img = {
                en: 'https://websiteoss.ecoflow.com/upload/image/1750400777411/EN.png',
                es: 'https://websiteoss.ecoflow.com/upload/image/1750400777228/ES.png',
                it: 'https://websiteoss.ecoflow.com/upload/image/1750400776858/IT.png',
                fr: 'https://websiteoss.ecoflow.com/upload/image/1750400777061/FR.png',
                de: 'https://websiteoss.ecoflow.com/upload/image/1750400776666/DE.png',
            };
            return img[locale as 'en'] || img['en'];
        })(),
        buck: 'https://websiteoss.ecoflow.com/upload/image/1749020680506/buck.png',
        buck10: (() => {
            const img = {
                en: 'https://websiteoss.ecoflow.com/upload/image/1750400870271/EN.png',
                de: 'https://websiteoss.ecoflow.com/upload/image/1750400869750/DE.png',
                fr: 'https://websiteoss.ecoflow.com/upload/image/1750400870445/FR.png',
                it: 'https://websiteoss.ecoflow.com/upload/image/1750400870642/IT.png',
                es: 'https://websiteoss.ecoflow.com/upload/image/1750400870118/ES.png',
            };
            return img[locale as 'en'] || img['en'];
        })(),
        gif2: 'https://websiteoss.ecoflow.com/upload/image/1755844766306/2.png',
        giftbag: 'https://websiteoss.ecoflow.com/upload/image/1749606432913/giftbag.png',
        giftcover: 'https://websiteoss.ecoflow.com/upload/image/1749025525343/giftcover.png',
    };
    const { point2x, point3x, off5, buck10, off18, giftbag, gif2, turntable, buck } = imgs;

    // 配合data-clipboard-text使用，不能删
    // @ts-ignore
    const clipboard = typeof window !== 'undefined' ? new ClipboardJS(`.rapid-pro-B .success-info-code`) : null;

    const items: ItemType[] = IS_EU
        ? [
              {
                  name: t('B_item1'),
                  text: t('B_item1_text'),
                  img: off18,
              },
              {
                  name: t('B_item2'),
                  text: t('B_item2_text'),
                  img: point3x,
              },
              {
                  name: t('B_item3'),
                  text: t('B_item3_text'),
                  linkText: t('B_item3_link'),
                  img: buck10,
                  link: `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID+Pro&powerbank-trade-in=true`,
              },
          ]
        : IS_JP
        ? [
              {
                  name: t('B_item1'),
                  img: point3x,
              },
              {
                  name: t('B_item2'),
                  img: giftbag,
                  // link: '/ecocredits',
              },
              //   {
              //       name: t('B_item3'),
              //       img: giftcover,
              //   },
              {
                  name: t('B_item4'),
                  img: off5,
              },
          ]
        : [
              {
                  name: t('B_item1'),
                  img: point2x,
              },
              {
                  name: t('B_item2'),
                  text: t('B_desc2'),
                  img: gif2,
              },
              {
                  name: t('B_item3'),
                  img: off5,
              },
              {
                  name: t('B_item4'),
                  img: buck,
              },
          ];

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput(e.target.value);
    };

    const handleFocus = () => {
        if (tip) setTip('');
    };

    const handleBlur = () => {
        if (!input) {
            return setTip(t('B_subscribe_empty'));
        }
        const email = input.trim();
        if (!regex.test(email)) {
            return setTip(t('B_subscribe_error'));
        }
        if (!check) {
            return setTip(t('B_subscribe_check'));
        }
    };

    const handleCheck = (e: HTMLInputElement) => {
        setCheck(e.checked);
    };

    const handleSubmit = async () => {
        const email = input.trim();
        if (!email) {
            return setTip(t('B_subscribe_empty'));
        }
        if (!regex.test(email)) {
            return setTip(t('B_subscribe_error'));
        }
        if (!check) {
            return setTip(t('B_subscribe_check'));
        }
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateString = `${year}-${month}-${day}`;
        const emailConfig = getEmailConfigs(dateString);
        const { contactListId, fields } = emailConfig[locale as keyof typeof emailConfig] || emailConfig['us'];
        const res = await fetchPost(
            `${baseUrl(locale)}/subscribe/new`,
            locale,
            {
                contactListId: contactListId[0],
                email,
                fields,
                source: 'WEB_NEW_PRODUCT_SUB',
                otherContactListIds: contactListId.slice(1),
                eventTracking: subscribeCookie({
                    sector_name: t('B_title'),
                    entry_position: 2,
                }),
            },
            {
                headers: {
                    apiKey: '527760f6df93c0d6e98609fa8e8a1f4a',
                },
            },
        );
        if (res?.code === '0') {
            // setTip(t('B_subscribe_success'));
            setSubmit(true);
            setInput('');
            setTimeout(() => {
                setTip('');
            }, 3000);
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_submit',
                button_name: t('B_submit'),
                status: 'success',
                tag: 'Agree',
                __btn_id1: `${css.section} .submit`,
                __btn_id2: t('B_submit'),
                __btn_type: 'text',
            });
            // gtm.push({
            //     event: 'uaEvent',
            //     event_name: 'activity_submit',
            //     button_name: t('B_submit'),
            //     status: 'success',
            //     tag: 'Agree',
            //     product_name: 'EcoFlow Rapid Pro',
            // });
        } else {
            setTip(res?.message);
            console.error(res?.message);
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_submit',
                button_name: t('B_submit'),
                status: 'fail',
                tag: 'Agree',
                __btn_id1: `${css.section} .submit`,
                __btn_id2: t('B_submit'),
                __btn_type: 'text',
            });
            // gtm.push({
            //     event: 'uaEvent',
            //     event_name: 'activity_submit',
            //     button_name: t('B_submit'),
            //     status: 'fail',
            //     tag: 'Agree',
            //     product_name: 'EcoFlow Rapid Pro',
            // });
        }
    };

    const handleCopy = () => {
        if (!copy) {
            setCopy(true);
            setTimeout(() => {
                setCopy(false);
            }, 3000);
            gtm.push({
                __btn_id1: `${css.section} .success-info-code`,
                __btn_id2: CODE,
                __btn_type: 'common',
            });
        }
    };

    const handleOpenModal = () => {
        setVisible(true);
        gtm.push({
            __btn_id1: `${css.section} .items-memo`,
            __btn_id2: t('B_memo_title'),
            __btn_type: 'text',
        });
    };

    const handleCloseModal = () => {
        setVisible(false);
    };

    useEffect(() => {
        setSubmit(getIsLogin());
    }, []);

    useEffect(() => {
        const countdownEndFn = async () => {
            let times: any = null;
            let end = 0;
            try {
                times = await require(`../../config/times/${locale}.js`);
            } catch (e) {
                times = await require(`../../config/times/us.js`);
            }

            if (times?.timeLine?.member?.start) {
                end = new Date(times.timeLine.member.start).getTime();
                if (query?._timer) {
                    end = end - new Date(query?._timer + ' GMT+8').getTime() + new Date().getTime();
                }
                setCountdownEnd(end);
            }
        };
        countdownEndFn();
    }, [query, locale]);

    return (
        <div
            id="rapid-pro-B"
            className={`rapid-pro-B ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-pro-B'}
            style={{ '--length': items.length }}
        >
            <EcoSpace />
            <div className="info">
                <p className="info-title">{t('B_title')}</p>
                <div className="coundown-wrapper">
                    {t('B_countdown') && <p className="countdown-prefix">{t('B_countdown')}</p>}
                    <div className="countdown-body">
                        <EcoCountDown className="info-countdown" endTime={countdownEnd} />
                        <ul className="countdown-suffix">
                            <span className="countdown-suffix-unit">{t('B_time_d')}</span>

                            <span className="countdown-suffix-unit">{t('B_time_h')}</span>
                            <span className="countdown-suffix-unit">{t('B_time_m')}</span>
                            <span className="countdown-suffix-unit">{t('B_time_s')}</span>
                        </ul>
                    </div>
                </div>
                {IS_JP && (
                    <>
                        <div className="subscribe" style={{ display: `${submit ? 'none' : 'block'}` }}>
                            <p className="subscribe-title">{t('B_subscribe')}</p>
                            <div className="subscribe-control">
                                <input
                                    type="text"
                                    className="subscribe-control-input"
                                    placeholder={t('B_placeholder')}
                                    value={input}
                                    onInput={handleInput}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                />
                                <button className="subscribe-control-button GtmModuleData-btn-text" onClick={handleSubmit}>
                                    {t('B_submit')}
                                </button>
                            </div>
                            <div className="check">
                                <input id="rapid-pro-check-A" type="checkbox" className="checkbox" checked={check} onChange={handleCheck} />
                                {link1 && link2 && (
                                    <label className="check-text" htmlFor="rapid-pro-check-A">
                                        {t.rich('B_note', {
                                            link1: (tx: string) => (
                                                <EcoLink
                                                    href={link1}
                                                    className="GtmModuleData-btn-href link-1"
                                                    dataLayer={{
                                                        __btn_id1: `${css.section} .link-1`,
                                                        __btn_id2: link1,
                                                        __btn_type: 'href',
                                                    }}
                                                >
                                                    {tx}
                                                </EcoLink>
                                            ),
                                            link2: (tx: string) => (
                                                <EcoLink
                                                    href={link2}
                                                    className="GtmModuleData-btn-href link-2"
                                                    dataLayer={{
                                                        __btn_id1: `${css.section} .link-2`,
                                                        __btn_id2: link2,
                                                        __btn_type: 'href',
                                                    }}
                                                >
                                                    {tx}
                                                </EcoLink>
                                            ),
                                        })}
                                    </label>
                                )}
                            </div>
                            {tip && <p className={`subscribe-tip${t('B_subscribe_success2') === tip ? ' success' : ''}`}>{tip}</p>}
                        </div>
                        <div className="success" style={{ display: submit ? 'block' : 'none' }}>
                            <EcoImg
                                className="success-img"
                                pc="https://websiteoss.ecoflow.com/upload/image/1747296683705/2.png"
                                h5="https://websiteoss.ecoflow.com/upload/image/1747297872344/2_M.png"
                            />
                            <div className="success-info">
                                <p className="success-info-text">{t('B_subscribe_success')}</p>
                                <div className="success-info-code GtmModuleData-btn-common" data-btn-id={CODE} data-clipboard-text={CODE} onClick={handleCopy}>
                                    <span className="success-info-code-text">{CODE}</span>
                                    <svg
                                        className="success-info-code-copy"
                                        width="29"
                                        height="28"
                                        viewBox="0 0 29 28"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect x="9.83325" y="9.33325" width="14" height="14" rx="1.16667" stroke="#5E72EE" strokeWidth="1.5" />
                                        <path
                                            d="M9.83342 18.6667H6.33341C5.68908 18.6667 5.16675 18.1444 5.16675 17.5001V5.83342C5.16675 5.18908 5.68908 4.66675 6.33341 4.66675H18.0001C18.6444 4.66675 19.1667 5.18908 19.1667 5.83341V9.33342"
                                            stroke="#5E72EE"
                                            strokeWidth="1.5"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className={`notify${copy ? ' active' : ''}`}>{t('B_copy')}</div>
                    </>
                )}
            </div>
            <ul className="items">
                {items.map((item: ItemType, k: number) => {
                    return (
                        <li key={k} className={`items-item${IS_EU ? ' eu' : ''}`}>
                            <EcoImg className="items-item-img" pc={item.img} />
                            <EcoLink href={item.href} className="items-item-info">
                                <p className="items-item-name">{item.name}</p>
                                {item?.text && <p className="items-item-text">{item.text}</p>}
                                {item?.link && item?.linkText && (
                                    <EcoLink
                                        className={`items-item-link GtmModuleData-btn-href item-${k + 1}`}
                                        href={item.link}
                                        dataLayer={{
                                            __btn_id1: `${css.section} .item-${k + 1}`,
                                            __btn_id2: item.link,
                                            __btn_type: 'href',
                                        }}
                                    >
                                        {item.linkText}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                            <path
                                                d="M8 15L13 10L8 5"
                                                stroke="currentColor"
                                                strokeWidth="1.66667"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </EcoLink>
                                )}
                            </EcoLink>
                        </li>
                    );
                })}
            </ul>
            <p className="items-memo GtmModuleData-btn-text" onClick={handleOpenModal}>
                {t('B_memo_title')}
            </p>
            <Dialog open={visible} onClose={handleCloseModal} />
        </div>
    );
};

export default B;
